import classnames from 'classnames';
import React, { TextareaHTMLAttributes } from 'react';

const CSS = require('./Textarea.module.scss');

interface TextareaProps extends TextareaHTMLAttributes<any> {
  hasError?: boolean;
}

function Textarea({ className, rows = 6, hasError, ...rest }: TextareaProps) {
  const classes = classnames(CSS.TextArea, {
    [CSS.Error]: hasError,
    [className]: className,
  });

  return <textarea className={classes} rows={rows} {...rest} />;
}

export default Textarea;
